<template>
  <div class="register_page">
    <!--Top Background-->
    <div class="top_background">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="title">
              <h4>{{ $t("cvsteps.title") }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Top Background-->
    <!--Cv Steps Page-->
    <div class="cv_steps_page">
      <div class="container">
        <div class="register_wizard_form">
          <div class="wizard_title">
            <h4>{{ $t("cvsteps.wizard_title") }}</h4>
            <p>{{ $t("cvsteps.wizard.desc") }}</p>
          </div>
          <!--Progress Bar-->
          <div class="progress_bar">
            <ul>
              <li :class="{ active: step == 1 }">
                <h4>01 {{ $t("cvsteps.wizard.chooseTemplate") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 2 }">
                <h4>02 {{ $t("cvsteps.wizard.pay") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
              <li :class="{ active: step == 3 || step == 4 }">
                <h4>03 {{ $t("cvsteps.wizard.fillData") }}</h4>
                <p>
                  <span></span>
                </p>
              </li>
            </ul>
          </div>
          <!--Progress Bar-->

          <!--Cv Data-->
          <template v-if="step == 4">
            <template-four
              :item="cvData"
              v-if="tempLang == 'ar' || tempLang == 'both'"
            ></template-four>
            <button
              type="button"
              class="main_button button mt-3"
              @click="downloadPdf()"
              v-if="tempLang == 'ar' || tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>
            <template-four-en
              :item="cvData"
              v-if="tempLang == 'en' || tempLang == 'both'"
            ></template-four-en>
            <button
              type="button"
              class="main_button button mt-3"
              @click="downloadPdf_en()"
              v-if="tempLang == 'en' || tempLang == 'both'"
            >
              <span>{{ $t("download") }}</span>
            </button>

            <vue-html2pdf
              :show-layout="controlValue.showLayout"
              :float-layout="controlValue.floatLayout"
              :enable-download="controlValue.enableDownload"
              :preview-modal="controlValue.previewModal"
              :filename="controlValue.filename"
              :paginate-elements-by-height="
                controlValue.paginateElementsByHeight
              "
              :pdf-quality="controlValue.pdfQuality"
              :pdf-format="controlValue.pdfFormat"
              :pdf-orientation="controlValue.pdfOrientation"
              :pdf-content-width="controlValue.pdfContentWidth"
              :manual-pagination="controlValue.manualPagination"
              :html-to-pdf-options="htmlToPdfOptions"
              @progress="onProgress($event)"
              @startPagination="startPagination()"
              @hasPaginated="hasPaginated()"
              @beforeDownload="beforeDownload($event)"
              @hasDownloaded="hasDownloaded($event)"
              ref="html2Pdf"
            >
              <section slot="pdf-content">
                <template-four
                  :item="cvData"
                  v-if="tempLang == 'ar' || tempLang == 'both'"
                ></template-four>
                <!-- <div class="html2pdf__page-break" /> -->
                <!-- <template-one-en
                  :item="cvData"
                  v-if="tempLang == 'en' || tempLang == 'both'"
                ></template-one-en> -->
              </section>
            </vue-html2pdf>

            <vue-html2pdf
              :show-layout="controlValue.showLayout"
              :float-layout="controlValue.floatLayout"
              :enable-download="controlValue.enableDownload"
              :preview-modal="controlValue.previewModal"
              :filename="controlValue.filename"
              :paginate-elements-by-height="
                controlValue.paginateElementsByHeight
              "
              :pdf-quality="controlValue.pdfQuality"
              :pdf-format="controlValue.pdfFormat"
              :pdf-orientation="controlValue.pdfOrientation"
              :pdf-content-width="controlValue.pdfContentWidth"
              :manual-pagination="controlValue.manualPagination"
              :html-to-pdf-options="htmlToPdfOptions"
              @progress="onProgress($event)"
              @startPagination="startPagination()"
              @hasPaginated="hasPaginated()"
              @beforeDownload="beforeDownload($event)"
              @hasDownloaded="hasDownloaded($event)"
              ref="html2Pdf_en"
            >
              <section slot="pdf-content">
                <!-- <template-one
                  :item="cvData"
                  v-if="tempLang == 'ar' || tempLang == 'both'"
                ></template-one>
                <div class="html2pdf__page-break" /> -->
                <template-four-en
                  :item="cvData"
                  v-if="tempLang == 'en' || tempLang == 'both'"
                ></template-four-en>
              </section>
            </vue-html2pdf>

            <div class="actions_btns">
              <router-link
                :to="`/editCv/${tempLang}/${id}`"
                class="main_button button mt-3"
              >
                <span>{{ $t("edit") }}</span>
              </router-link>
            </div>
          </template>
          <!--Cv Data-->
        </div>
      </div>
    </div>
    <!--Cv Steps Page-->
  </div>
</template>

<script>
import TemplateFour from "../../../components/CvTemplate/TemplateFour.vue";
import TemplateFourEn from "../../../components/CvTemplate/TemplateFourEn.vue";
import html2canvas from "html2canvas";
import VueHtml2pdf from "vue-html2pdf";
import * as moment from "moment/moment";
export default {
  props: ["tempLang", "id"],
  components: {
    TemplateFour,
    TemplateFourEn,
    VueHtml2pdf,
  },
  data() {
    return {
      //Progress Step
      // step: 1,
      //Progress Step

      cvData: null,

      //Data
      allData: null,

      //loading
      loading: false,

      //   tempNum: null,
      //   tempPrice: null,
      //   tempLang: null,

      //Show Model
      show: false,

      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
      controlValue: {
        showLayout: false,
        floatLayout: true,
        enableDownload: false,
        previewModal: true,
        paginateElementsByHeight: 2999,
        manualPagination: true,
        filename: "Captin1 Report",
        pdfQuality: 2,
        pdfFormat: "a4",
        pdfOrientation: "portrait",
        pdfContentWidth: "800px",
      },
    };
  },
  methods: {
    async downloadPdf() {
      if (!(await this.validateControlValue())) return;
      this.$refs.html2Pdf.generatePdf();
    },
    async downloadPdf_en() {
      if (!(await this.validateControlValue())) return;
      this.$refs.html2Pdf_en.generatePdf();
    },
    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 2;
        return false;
      }
      if (!this.controlValue.paginateElementsByHeight) {
        alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 11.7;
        return false;
      }
      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];
      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        alert(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";
        return false;
      }
      if (!this.controlValue.pdfOrientation) {
        alert("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";
        return false;
      }
      if (!this.controlValue.pdfContentWidth) {
        alert("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";
        return false;
      }
      return true;
    },
    onProgress(progress) {
      this.progress = progress;
      console.log(`PDF generation progress: ${progress}%`);
    },
    startPagination() {
      console.log(`PDF has started pagination`);
    },
    hasPaginated() {
      console.log(`PDF has been paginated`);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      console.log(`On Before PDF Generation`);
    },
    async toDataUrLImage(res) {
      return await this.toDataUrl(res);
    },
    hasDownloaded(blobPdf) {
      console.log(`PDF has downloaded yehey`);
      this.pdfDownloaded = true;
      console.log(blobPdf);
    },
    domRendered() {
      console.log("Dom Has Rendered");
      this.contentRendered = true;
    },
    onBlobGenerate(blob) {
      console.log(blob);
      console.log(blob);
    },

    //Cv Details
    getCv() {
      this.$axios({
        method: "GET",
        url: "cv_design_details?cv_id=" + this.id,
      }).then((res) => {
        this.cvData = res.data.data;
      });
    },

    //Country Code
    onSelect({ name, iso2, dialCode }) {
      console.log(name, iso2, dialCode);
      this.data.code = dialCode;
    },
    takeshot() {
      let div = document.getElementById("one_ar");

      // Use the html2canvas
      // function to take a screenshot
      // and append it
      // to the output div
      html2canvas(div).then(function (canvas) {
        document.getElementById("output").appendChild(canvas);
      });
    },
  },
  mounted() {
    this.getCv();
  },
  created() {
    this.$store.dispatch("cv_module/addStep", {
      step: 4,
    });
  },
  computed: {
    step() {
      return this.$store.getters["cv_module/cvStep"];
    },
    cv_id() {
      return this.$store.getters["cv_module/cvId"];
    },
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: "cv.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      };
    },
  },
};
</script>

<style>
.skill_item {
  margin-bottom: 15px;
}

.skill_item span {
  font-size: 15px;
  display: flex;
  margin-bottom: 4px;
}

.range {
  width: 400px;
  height: 15px;
  -webkit-appearance: none;
  background: #cecece;
  direction: ltr;
  outline: none;
  border-radius: 0px;
  overflow: hidden;
  /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 1); */
}
.range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #0eb6d8;
  cursor: pointer;
  border: 4px solid #fff;
  box-shadow: -407px 0 0 400px #0eb6d8;
}

.vue-country-select {
  margin-bottom: 15px;
  margin-inline-end: 5px;
}
</style>
